const REPORT_BASE = "user/api/client-api";
const COURSE_BASE = "course/api/client-api"
const LOGIN_BASE = "/api/client-api/auth";


export const GET_SINGLE_USER_REPORT   = `${REPORT_BASE}/reports/user/`;
export const GET_SINGLE_GROUP_REPORT  = `${REPORT_BASE}/reports/group/`;
export const GET_SINGLE_COURSE_REPORT = `${REPORT_BASE}/reports/course/`;
export const GET_SINGLE_BUNDLE_REPORT = `${REPORT_BASE}/reports/bundle/`;
export const GET_ROLE = `${REPORT_BASE}/roles/user-dashboard`;



export const GET_USER_KPI_REPORT    = `${REPORT_BASE}/reports/kpi/users`;
export const GET_COURSE_KPI_REPORT  = `${REPORT_BASE}/reports/kpi/courses`;
export const GET_GROUP_KPI_REPORT   = `${REPORT_BASE}/report/groups`;
export const GET_BUNDLE_KPI_REPORT  = `${REPORT_BASE}/report/bundles`;


export const DOWNLOAD_USER_KPI_REPORT = `${REPORT_BASE}/reports/kpi/users/download`;
export const DOWNLOAD_GROUP_KPI_REPORT  = `${REPORT_BASE}/report/groups/download`;   
export const DOWNLOAD_BUNDLE_KPI_REPORT = `${REPORT_BASE}/reports/kpi/bundles/download`;
export const DOWNLOAD_COURSE_KIP_REPORT = `${REPORT_BASE}/report/courses/download`;
export const DOWNLOAD_GROUP_SINGLE_REPORT = `${REPORT_BASE}/reports/group/`;
export const GROUP_BASE = `${REPORT_BASE}/group`;

export const GET_ALL_GROUPS        = `${GROUP_BASE}/groups-paged`;
export const CREATE_GROUP          = `${GROUP_BASE}/create-group`;
export const UPDATE_GROUP          = `${GROUP_BASE}/update-group`;
export const DELETE_GROUP          = (groupId) => `${GROUP_BASE}/remove/${groupId}`;
export const GET_USERS_IN_GROUP    = (groupId) => `${GROUP_BASE}/group-emps/${groupId}`;
export const DELETE_SINGLE_USER    = `${GROUP_BASE}/remove-user`;
export const ADD_USER_TO_GROUP     = `${GROUP_BASE}/add-user`;
export const GET_COURSE_DETAILS    = (groupId) => `${GROUP_BASE}/group-courses/${groupId}`;
export const GET_COURSE_NAME_DETAILS = (groupId) => `${GROUP_BASE}/emp/group-courses/${groupId}`;
export const GET_USER_COURSES_IN_GROUP = `${GROUP_BASE}/user-courses`;
export const GET_USER_BUNDLES_IN_GROUP = `${GROUP_BASE}/user-bundles`;
export const GET_USER_GROUPS       = `${GROUP_BASE}/user/groups`;
export const GET_COURSES_BUNDLE    = (groupId)  =>  `${GROUP_BASE}/${groupId}/enrolled-items`;
export const EDIT_USER_DETAILS  =   `${REPORT_BASE}/admin/update-user/`;
export const CREATE_USER_DETAILS =   `${REPORT_BASE}/admin/register`;

export const GET_COURSE_CONTENT    =  `${COURSE_BASE}/course-content/course`;
export const DOWNLOAD_SINGLE_KPI_REPORT = `${REPORT_BASE}/reports/course/`;
export const Filter_Options_KPI_REPORT = `${REPORT_BASE}/reports/course/`;
//Admin Dashboard URLs

export const GET_DASHBOARD_STATS   = `${REPORT_BASE}/admin/admin-dashboard-stats`;
export const GET_RECENT_USERS      = `${REPORT_BASE}/admin/users/recent`;
export const GET_RECENT_COURSES    = `${REPORT_BASE}/course/recent-course-and-bundle`;
export const GET_RECENT_BUNDLE    = `${REPORT_BASE}/course-bundles/recent`;
export const GET_RECENT_GROUPS    = `${REPORT_BASE}/group/recent`;


export const GET_COURSES = `course/api/client-api/course`;
export const GET_ENROLLMENT_SUMMARY = (groupId) => `${GROUP_BASE}/${groupId}/enrollment-summary`;
export const Download_ALL_COURSE_REPORT = `${REPORT_BASE}/reports/kpi/courses/download`;

export const GET_USER_HISTORY_FILTER_OPTIONS = `${REPORT_BASE}/reports/user/`;

export const EDIT_COURSE_CONTENT = `${COURSE_BASE}/course-content/`;

export const QUIZ_BASE = "course/api/client-api";

export const DELETE_BUNDLE = (bundleId) => `${QUIZ_BASE}/bundles/${bundleId}`;
export const GET_BUNDLE_COURSES = `${COURSE_BASE}/course-bundles/bundle/bundlecourses`;

export const GET_QUIZ = (courseId) => `${QUIZ_BASE}/quizzes/course/${courseId}`;
export const GET_QUIZ_ADMIN = (courseId) => `${QUIZ_BASE}/quizzes/course/${courseId}/quiz`;
export const CREATE_QUIZ = `${QUIZ_BASE}/quizzes`;
export const UPDATE_QUIZ = (quizId) => `${QUIZ_BASE}/quizzes/${quizId}`;
export const GET_QUESTIONS_QUIZ = (quizId) => `${QUIZ_BASE}/quiz-questions/quiz/${quizId}`;
export const CREATE_QUESTION = `${QUIZ_BASE}/quiz-questions`;
export const UPDATE_QUESTION = (questionId) => `${QUIZ_BASE}/quiz-questions/${questionId}`;
export const DELETE_QUESTION = (questionId) => `${QUIZ_BASE}/quiz-questions/${questionId}`;
export const GET_QUIZ_ATTEMPT_META = (userId, courseId) =>
  `${QUIZ_BASE}/quiz-attempt/user/${userId}/quiz/course/${courseId}/meta`;

export const GET_QUIZ_ATTEMPT_DETAILS = (userId, courseId, attemptId) =>
  `${QUIZ_BASE}/quiz-attempt/user/${userId}/quiz/course/${courseId}/attempt/${attemptId}`;

export const GET_QUIZ_BY_COURSE = (courseId) => `${QUIZ_BASE}/quizzes/course/${courseId}`;
export const GET_QUIZ_BY_ID = (quizId) => `${QUIZ_BASE}/quizzes/${quizId}`;
export const CREATE_QUIZ_ATTEMPT = `${QUIZ_BASE}/quiz-attempt`;
export const GET_QUIZ_QUESTIONS_FOR_ATTEMPT = (quizId, attempt, userId) =>
  `${QUIZ_BASE}/quiz-questions/quiz/${quizId}/attempt/${attempt}/user/${userId}`;
export const SUBMIT_QUIZ = (attemptId) => `${QUIZ_BASE}/quiz-submissions/${attemptId}`;

export const GET_QUIZ_ATTEMPTS = (userId, courseId) =>
  `${QUIZ_BASE}/quiz-attempt/user/${userId}/quiz/course/${courseId}`;

export const STREAM_VIDEO = (fileName) =>
  `${process.env.REACT_APP_API_BASE_URL}/${QUIZ_BASE}/streaming/video/${fileName}`;
export const GET_LAST_POSITION = (userId, courseId, contentId) =>
  `${QUIZ_BASE}/user-progress/last-position?userId=${userId}&courseId=${courseId}&contentId=${contentId}`;

export const USER_LOGIN = `${LOGIN_BASE}/login`;
export const GOOGLE_LOGIN = `${LOGIN_BASE}/google-login`
